import React, {Component} from 'react';
import { Route } from "react-router-dom";
import '../App.css';
import '../css/all.css';



import UpperMenu from '../components/upper_menu/upper_menu.component'
import compose from '../utils/compose'
import withNofeshService  from '../hoc/withNofeshService.hoc';
import ModalOrderDisplay from '../components/modal_order/modal_order_display'
import ModalCancelOrderConfirmation from '../components/modal_order/modal_order_cancel_confirmation'
import ModalCancelOrderSuccess from '../components/modal_order/modal_order_cancel_success'
import ModalCancelOrderFailure from '../components/modal_order/modal_order_cancel_failure'



class OrderPage extends Component {


  state = {
    loading:true,
    employeeOrder :{},
    modalHotelDisplay:false,
    modalCancelOrderConfirmationDisplay:false,
    ModalCancelOrderSuccessDisplay:false,
    ModalCancelOrderFailureDisplay:false
  }


doCancelOrder = (obj) => {

    const { nofeshService } = this.props;
    this.setState({loading:true});

    nofeshService.cancelOrder(obj).then( res  => {    
      
        console.log('doCancelOrder cancelOrder res.data: ', res.data);
          let  resultObj = res.data;
          if (resultObj == 1) {
            this.setState({ModalCancelOrderSuccessDisplay:true}); 
            this.setState({modalCancelOrderConfirmationDisplay:false}); 
          }
          else{
            this.setState({ModalCancelOrderSuccessDisplay:false}); 
            this.setState({modalCancelOrderConfirmationDisplay:false}); 
            this.setState({ModalCancelOrderFailureDisplay:true}); 
            
          }
          this.setState({loading:false});             
      }); 
}

doCancelOrderConfirm = () => {
  this.setState({ModalCancelOrderSuccessDisplay:false}); 
  this.setState({modalCancelOrderConfirmationDisplay:true}); 
}


doNotCancelOrder = () => {
  this.setState({ModalCancelOrderSuccessDisplay:false}); 
  this.setState({modalCancelOrderConfirmationDisplay:false}); 
}

toggleConfirmation = () => {

    this.setState({modalCancelOrderConfirmationDisplay:true});  
}



  componentDidMount = () => {

      const orderId =  this.props.match.params.id;
      const { nofeshService } = this.props;
      nofeshService.getOrderDetailsById(orderId).then( res  => {

        let  resultObj = res.data;
        console.log('OrderPage componentDidMount getOrderDetailsById res', res);
        this.setState({employeeOrder: resultObj.employeeOrder, loading:false }); ;            
      }); 

  }




  render() {         


    return (      
        <div>                                   
            <div className="hp_banner">
                <UpperMenu   
                      personData={this.props.personData} 
                      onLoggedOutRefresh={this.props.onLoggedOutRefresh}/>

            </div>
    
            <div className="hp_container">  

             {(!this.state.modalCancelOrderConfirmationDisplay && 
               !this.state.ModalCancelOrderSuccessDisplay   &&
               !this.state.ModalCancelOrderFailureDisplay ) ?                                   
                <Route path="/order/:id" 
                    render={({match}) => {
                        const id = match.params;
                        return <ModalOrderDisplay 
                          employeeOrder={this.state.employeeOrder} 
                          doCancelOrderConfirm={this.doCancelOrderConfirm} />
                    }} />
                : null} 

                {(this.state.ModalCancelOrderSuccessDisplay) ?    
                <ModalCancelOrderSuccess 
                  employeeOrder={this.state.employeeOrder} />
                : null} 


                {(this.state.ModalCancelOrderFailureDisplay) ?    
                <ModalCancelOrderFailure 
                  employeeOrder={this.state.employeeOrder} />
                : null} 


                {(this.state.modalCancelOrderConfirmationDisplay) ?    
                <ModalCancelOrderConfirmation 
                  employeeOrder={this.state.employeeOrder} 
                  doCancelOrder={this.doCancelOrder}
                  doNotCancelOrder={this.doNotCancelOrder}
                  />
                : null} 

            </div>

            <div className="hp_footer">
            </div>
        </div>
    )
  }
}



export default compose(
    withNofeshService(),    
  )(OrderPage);



